import {useState} from 'react';

import {DialogContent, MenuItem} from '@mui/material';

import useProfile from '../../../../hooks/providers/useProfile';
import useWorkspaces from '../../../../hooks/providers/useWorkspaces';
import Button from '../../../form/buttons/Button/Button';
import FormUppercaseLabel from '../../../form/FormUppercaseLabel/FormUppercaseLabel';
import FormSelect from '../../../form/MuiSelect/MuiSelect';
import BaseModal from '../../../modal/BaseModal';

const SelectWorkspaceBeforeReportCreationModal = () => {
  const [workspace, setWorkspace] = useState('');
  const {profile} = useProfile();
  const {
    workspaces,
    isUserOwnerOfWorkspace,
    setSelectedWorkspace,
    isSelectWorkspaceBeforeReportCreationModalOpen: isOpen,
    setIsSelectWorkspaceBeforeReportCreationModalOpen: setIsOpen,
    setCreateReportModalOpen
  } = useWorkspaces();

  const userOwnedWorkspaces = workspaces.filter(w => isUserOwnerOfWorkspace(profile?.id, w));
  const workspacesItems = userOwnedWorkspaces.map(w => (
    <MenuItem value={w.workspace_id} key={w.workspace_id}>
      {w.workspace_name}
    </MenuItem>
  ));

  return (
    <BaseModal
      onClose={() => {
        setIsOpen(false);
      }}
      open={isOpen}
      title="Sélectionnez l'espace de travail"
    >
      <DialogContent sx={{p: 3}}>
        <FormUppercaseLabel label="Choisir l'espace de travail" />
        <FormSelect sx={{width: '100%', mt: 2, mb: 3}} label="Espace de travail" labelId="workspaces" value={workspace} onChange={e => setWorkspace(e.target.value)} items={workspacesItems} />
        <Button
          sx={{margin: '0 auto', display: 'block'}}
          disabled={!workspace}
          variant="contained"
          color="secondary"
          onClick={() => {
            setSelectedWorkspace(workspace);
            setIsOpen(false);
            setCreateReportModalOpen(true);
          }}
        >
          Choisir cet espace
        </Button>
      </DialogContent>
    </BaseModal>
  );
};

SelectWorkspaceBeforeReportCreationModal.propTypes = {};

export default SelectWorkspaceBeforeReportCreationModal;
